import { render, staticRenderFns } from "./TambahICDX.vue?vue&type=template&id=e7c839fe"
import script from "./TambahICDX.vue?vue&type=script&lang=js"
export * from "./TambahICDX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7c839fe')) {
      api.createRecord('e7c839fe', component.options)
    } else {
      api.reload('e7c839fe', component.options)
    }
    module.hot.accept("./TambahICDX.vue?vue&type=template&id=e7c839fe", function () {
      api.rerender('e7c839fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/icdx/TambahICDX.vue"
export default component.exports